/**
 * Created by tayloremolo on 10/20/17.
 */
import React, {Component} from 'react';
import ReactDOM from "react-dom";
import IframeVideo from "../components/iframe-video";
import CTA from "../components/cta";

class Header extends Component {
    // constructor() {
    //     super();
    //
    // }
    // componentDidMount(){
    //     });
    // }

    render() {
        return (
            <div>
                <div className="section-1-et">
                    <div className="container p-40">
                        <div className="row mb0 p-40">
                            <div className="col s12 center-align">
                                <h1 className="f-38 white-text bold-text text-uppercase">Eric Thomas <span className="text-normal">& <br className="hide-on-med-and-up"/> </span> F<span className="brand-text">OWN</span>ders <span className="text-normal">Presents <br/></span> <span className="f-TO">Take <span className="brand-text">Own</span>ership</span></h1>
                                <div className="video-container">
                                    <IframeVideo/>
                                </div>
                                <br/>
                                <a href="http://www.fownders.co/mastermind-step-1" className="btn-large cta-org waves-effect waves-light">RESERVE YOUR SPOT</a>
                                <br/>
                                <br/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )


    }

}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js